module.exports = __webpack_public_path__ + "img/NORDIC_PROCESSED_MEATS.91fae602.png";